document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.content.input.required abbr[title="required"]').forEach(function (e) {
        e.hidden = true
    });

    document.querySelectorAll(".input.required input:read-only, .input.required input:disabled").forEach(function (e) {
        let abbr = e.parentNode.querySelector('abbr[title="required"]')
        if (abbr !== null) {
            abbr.hidden = true;
        }
    });
});
